const initialState = {
    data: null,
};

export const DeleteUserImageReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DELETEUSERIMAGE_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'DELETEUSERIMAGE_FAILURE':
            return {
                ...state,
                error: action.payload,
            };
        case 'DELETEUSERIMAGE_RESET':
            return initialState;
        default:
            return state;
    }
}

export default DeleteUserImageReducer;